import { gql } from '@apollo/client'

export const EXPORT_SALES_QUERY = gql`
  query SalesActivities(
    $first: Int
    $after: String
    $where: SalesActivitiesGraphQlFilterInput
    $order: [SalesActivitiesGraphQlSortInput!]
  ) {
    salesActivities(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        channel
        countryName
        regionIdentifier
        referenceProducts
        category
        impactLossFactor
        carbon
        waterUsage
        eutrophication
        comment
        secondaryDataReferenceSourceType
        dataQualityReliabilityScore
        referenceDataPublicationYear
        referenceSourcingCountry
        referenceRegionIdentifier
        referencesSamplingYear
        dataQualityComment
        lastPublishedDate
        researcherName
        researcherEmail
        isVerified
        verificationComments
        verifiedOn
        verifiedByName
        verifiedByEmail
        updated
        lastUpdatedName
        userId
        userEmail
        countryId
        regionIdentifierId
        temperatureConditions
        shelfLife
        companyId
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
